import { memo } from "react";
import { ColorPicker, Slider, InputNumber, Select } from "antd";
import styled from "styled-components";
import { LayerStyles, colorToHex, dashOptions } from "../types";

interface LineStyleTabProps {
  styles: LayerStyles;
  onUpdate: (field: keyof LayerStyles['line'], value: any) => void;
}

const LineStyleTab = ({ styles, onUpdate }: LineStyleTabProps) => {
  return (
    <StyleForm>
      <FormRow>
        <FormLabel>Màu đường:</FormLabel>
        <ColorPicker
          value={styles.line.color}
          onChange={(color) => onUpdate('color', colorToHex(color))}
          showText
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ dày:</FormLabel>
        <Slider
          min={1}
          max={10}
          value={styles.line.width}
          onChange={(value) => onUpdate('width', value)}
          style={{ flex: 1 }}
        />
        <InputNumber
          min={1}
          max={10}
          value={styles.line.width}
          onChange={(value) => onUpdate('width', value || 3)}
          style={{ width: 60 }}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ mờ:</FormLabel>
        <Slider
          min={0}
          max={1}
          step={0.1}
          value={styles.line.opacity}
          onChange={(value) => onUpdate('opacity', value)}
          style={{ flex: 1 }}
        />
        <span style={{ width: 60, textAlign: 'center' }}>
          {Math.round(styles.line.opacity * 100)}%
        </span>
      </FormRow>

      <FormRow>
        <FormLabel>Kiểu đường:</FormLabel>
        <Select
          value={styles.line.dashPattern}
          onChange={(value) => onUpdate('dashPattern', value)}
          options={dashOptions}
          style={{ flex: 1 }}
        />
      </FormRow>
    </StyleForm>
  );
};

export default memo(LineStyleTab);

const StyleForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FormLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  min-width: 120px;
`;
